import { useEffect } from 'react';
import PropTypes from 'prop-types';

// Renders nothing. Reports the wrapped form's submit state to ModalEditForm,
// which renders the footer buttons outside the form.
const ModalEditFormSubmitState = ({ onChange, submitting, submitDisabled }) => {
  useEffect(() => {
    onChange({ submitting, submitDisabled });
  }, [onChange, submitting, submitDisabled]);

  return null;
};

ModalEditFormSubmitState.propTypes = {
  onChange: PropTypes.func.isRequired,
  submitDisabled: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default ModalEditFormSubmitState;
